import React from 'react';
import { SimpleForm, Edit, TextInput, BooleanInput, ReferenceInput, SelectInput } from 'react-admin';
import { required } from 'ra-core';
import { NameTitle } from '../../utils/Title.component';
import ScreenDescription from '../ScreenDescription';
import SaveOnlyToolbar from '../SaveOnlyToolbar';

// Reclassificar aqui (bloco/tipo) não mexe em nenhuma mensagem já enviada —
// o relatório de volumetria sempre junta pela fonte no momento da consulta,
// então a mudança já vale pro histórico inteiro e pro que vier depois.
const SourceEdit = props => (
  <>
    <ScreenDescription>
      "Kind" e "Flow key" são definidos pelo sistema no primeiro envio e não podem ser editados — "template" é uma mensagem com
      modelo aprovado na Twilio, "free_form" é texto livre de sessão. Trocar Bloco e/ou Tipo aqui reclassifica{' '}
      <strong>todo o histórico</strong> dessa fonte de uma vez, sem precisar editar mensagem por mensagem. Não existe exclusão de
      fonte — só desativação.
    </ScreenDescription>
    <Edit {...props} title={<NameTitle model="Fonte" record={props} />}>
      <SimpleForm toolbar={<SaveOnlyToolbar />}>
        <TextInput source="name" label="Nome" validate={required()} />
        <TextInput source="kind" label="Kind" disabled />
        <TextInput source="flowKey" label="Flow key" disabled />
        <ReferenceInput label="Bloco" source="blockId" reference="whatsapp_block" validate={required()}>
          <SelectInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput label="Tipo" source="messageTypeId" reference="whatsapp_message_type" allowEmpty>
          <SelectInput optionText="name" />
        </ReferenceInput>
        <BooleanInput source="active" label="Ativo" />
      </SimpleForm>
    </Edit>
  </>
);

export default SourceEdit;
